export * from './lib/new-plan/new-plan.component';
